const toString = Object.prototype.toString

/**
 * @description: 判断值是否未某个类型
 */
export function is(val: unknown, type: string) {
	return toString.call(val) === `[object ${type}]`
}

/**
 * @description: 是否已定义
 */
export const isDef = <T = unknown>(val?: T): val is T => {
	return typeof val !== 'undefined'
}

export const isUnDef = <T = unknown>(val?: T): val is T => {
	return !isDef(val)
}
/**
 * @description: 是否为对象
 */
export const isObject = (val: any): val is Record<any, any> => {
	return val !== null && is(val, 'Object')
}

/**
 * @description: 是否空对象
 */
export function isEmptyObject(obj: Recordable<unknown>) {
	return Object.keys(obj).length === 0
}

/**
 * @description:  是否为时间
 */
export function isDate(val: unknown): val is Date {
	return is(val, 'Date')
}

/**
 * @description:  是否为数值
 */
export function isNumber(val: unknown): val is number {
	return is(val, 'Number')
}

/**
 * @description:  是否为AsyncFunction
 */
export function isAsyncFunction<T = any>(val: unknown): val is Promise<T> {
	return is(val, 'AsyncFunction')
}

/**
 * @description:  是否为字符串
 */
export function isString(val: unknown): val is string {
	return is(val, 'String')
}

/**
 * @description:  是否为boolean类型
 */
export function isBoolean(val: unknown): val is boolean {
	return is(val, 'Boolean')
}

/**
 * @description:  是否为数组
 */
export function isArray(val: any): val is Array<any> {
	return val && Array.isArray(val)
}

/**
 * @description: 是否客户端
 */
export const isClient = () => {
	return typeof window !== 'undefined'
}

/**
 * @description: 是否手机端
 */
export const isMobile = () => {
	return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

/**
 * @description: 是否为浏览器
 */
export const isWindow = (val: any): val is Window => {
	return typeof window !== 'undefined' && is(val, 'Window')
}

/**
 * @description: 是否为视频文件
 */
export const isVideo = (val: string) => {
	// 如果包含 x-oss-process=video/snapshot，则认为是图片（视频截图）
	if (val.includes('x-oss-process=video/snapshot')) {
		return false
	}
	return /\.(mp4|webm|ogg|mp3|wav|flac|aac|m4a|MOV)(\?.*)?$/i.test(val)
}

export const isElement = (val: unknown): val is Element => {
	return isObject(val) && !!val.tagName
}

export const isServer = typeof window === 'undefined'

// 是否为图片节点
export function isImageDom(o: Element) {
	return o && ['IMAGE', 'IMG'].includes(o.tagName)
}

export function isNull(val: unknown): val is null {
	return val === null
}

export function isNullAndUnDef(val: unknown): val is null | undefined {
	return isUnDef(val) && isNull(val)
}

export function isNullOrUnDef(val: unknown): val is null | undefined {
	return isUnDef(val) || isNull(val)
}

/**
 * URL地址
 * @param {*}
 */
export const isURL = (s: string): boolean => /^http[s]?:\/\/.*/.test(s)

/**
 * 判断是否是IE
 */
export const isIE = () => {
	const bw = window.navigator.userAgent
	const compare = (s: string) => bw.indexOf(s) >= 0
	const ie11 = (() => 'ActiveXObject' in window)()
	return compare('MSIE') || ie11
}
